import { WarehouseLoggedHoursType } from "services/BillingEngineService/interfaces/entities/WarehouseLoggedHours";

const hourOptions = Array.from({ length: 13 }, (_, i) => i);

const minuteOptions = [0, 15, 30, 45];

const projectOptions: WarehouseLoggedHoursType[] = ["wros", "special-projects"];

const hoursLoggedQueryKey = "hours-logged";

export { hourOptions, minuteOptions, projectOptions, hoursLoggedQueryKey };
